import { arrayToObj } from '../../utils/customMethods'

const initialStatus = {
  loading: false,
  success: false,
  error: false,
  data: null,
  message: null,
}

const initialState = { form: [], conversations: {} }

const tabReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'RESET_TABS_OBJ':
      return {}
    case 'RESET_TABS_STATUS':
      return {
        ...state,
        status: {
          ...state.status,
          [action.payload]: initialStatus,
        },
      }
    case 'TABS_ERROR':
      return {
        ...state,
        status: {
          ...state?.status,
          [action?.payload?.action]: {
            ...initialStatus,
            error: true,
            message: action?.payload?.message,
          },
        },
      }
    case 'GET_TABS':
      return {
        ...state,
        status: {
          get_tabs: {
            ...initialStatus,
            loading: true,
            data: { ...action.payload },
          },
        },
      }
    case 'SET_TABS': {
      const form = arrayToObj(state.form, 'id')
      const newTabs = arrayToObj(action.payload.data, 'id')

      // Add/update values, and after that convert data to array again
      const tabs = Object.values({ ...form, ...newTabs })

      return {
        ...state,
        form: { ...state.form, [action.payload.skillId]: tabs },
        status: {
          get_tabs: {
            ...initialStatus,
            success: true,
          },
        },
      }
    }
    case 'GET_TAB':
      return {
        ...state,
        status: {
          get_tab: {
            ...initialStatus,
            loading: true,
            data: { ...action.payload },
          },
        },
      }
    case 'SET_TAB': {
      const tabId = action.payload.tabId
      const chatId = action.payload.chatId

      return {
        ...state,
        conversations: {
          ...state.conversations,
          [chatId]: tabId,
        },
        status: {
          ...state.status,
          get_tab: {
            ...initialStatus,
            success: true,
          },
        },
      }
    }

    default:
      return state
  }
}

export default tabReducer
